import i18n from '@/i18n';
import { RouteRecordRaw } from 'vue-router';

const poolRoutes: Array<RouteRecordRaw> = [
   {
      path: '',
      name: 'pool-overview',
      component: () => import('@/modules/pool/components/overview/Overview.vue'),
      meta: {
         title: `${i18n.global.t('global.pools', 2)} - NxtPlan`,
      },
   },
   {
      path: ':poolId',
      name: 'pool-details',
      component: () => import('@/modules/pool/components/poolDetails/PoolDetails.vue'),
      meta: {
         parent: 'pool-details',
      },
      redirect: { name: 'pool-details-candidates-all' },
      children: [
         {
            path: 'candidates/all',
            name: 'pool-details-candidates-all',
            component: () => import('@/modules/pool/components/poolDetails/CandidatePoolList.vue'),
            meta: {
               title: '{pool.pool.name} - NxtPlan',
            },
         },
         {
            path: 'settings',
            name: 'pool-settings',
            components: {
               default: () => import('@/modules/pool/components/poolDetails/CandidatePoolList.vue'),
               settings: () => import('@/modules/pool/components/poolDetails/PoolSettings.vue'),
            },
            redirect: { name: 'pool-settings-general' },
            meta: {
               title: `${i18n.global.t('pool.pool_settings')}`,
            },
            children: [
               {
                  path: 'general',
                  name: 'pool-settings-general',
                  components: {
                     side_modal: () => import('@/modules/pool/components/poolDetails/poolSettings/General.vue'),
                  },
               },
               {
                  path: 'rights',
                  name: 'pool-settings-rights',
                  components: {
                     side_modal: () => import('@/modules/pool/components/poolDetails/poolSettings/Permissions.vue'),
                  },
               },
               {
                  path: 'tags',
                  name: 'pool-settings-tags',
                  components: {
                     side_modal: () => import('@/core/components/tags/Tags.vue'),
                  },
               },
               {
                  path: 'availabilities',
                  name: 'pool-settings-focus-period',
                  components: {
                     side_modal: () => import('@/modules/pool/components/poolDetails/poolSettings/PoolFocusPeriods.vue'),
                  },
               },
               {
                  path: 'preferences',
                  name: 'pool-details-settings-preferences',
                  components: {
                     side_modal: () => import('@/modules/pool/components/poolDetails/poolSettings/Preferences.vue'),
                  },
               },
               {
                  path: 'contracts',
                  name: 'pool-details-settings-contracts',
                  components: {
                     side_modal: () => import('@/modules/pool/components/poolDetails/poolSettings/poolContracts.vue'),
                  },
               },
            ],
         },
         {
            path: 'import',
            name: 'pool-details-import',
            components: {
               default: () => import('@/modules/pool/components/poolDetails/CandidatePoolList.vue'),
               settings: () => import('@/modules/pool/components/poolDetails/PoolImport.vue'),
            },
            redirect: { name: 'pool-details-import-candidates' },
            meta: {
               title: `${i18n.global.t('board.import')}`,
            },
            children: [
               {
                  path: 'candidates',
                  name: 'pool-details-import-candidates',

                  components: {
                     side_modal: () => import('@/modules/pool/components/poolDetails/imports/ImportCandidates.vue'),
                  },
               },
               {
                  path: 'pool-structure',
                  name: 'pool-details-import-structure',
                  components: {
                     side_modal: () => import('@/modules/pool/components/poolDetails/imports/ImportStructure.vue'),
                  },
               },
               {
                  path: 'syntegro',
                  name: 'pool-details-import-syntegro',
                  components: {
                     side_modal: () => import('@/modules/pool/components/poolDetails/imports/ImportSyntegro.vue'),
                  },
               },
            ],
         },
      ],
   },
];
export default poolRoutes;
